import { z } from 'zod';

export const SERVICE_TYPES = [
  'Stucco Repair',
  'Plaster Installation',
  'Lath Work',
  'Texture Matching',
  'Drywall Repair',
  'Drywall Installation',
] as const;

export const contactFormSchema = z.object({
  name: z.string().min(2, 'Name is required'),
  email: z.string().email('Valid email required'),
  phone: z.string().min(7, 'Phone is required'),
  message: z.string().min(10, 'Message must be at least 10 characters'),
  serviceType: z.enum(SERVICE_TYPES, { error: 'Please select a service' }),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
